<template>
  <div v-if="isOpen" class="navigation-overlay">
    <div class="page-overlay">
      <div class="content-wrapper">
        <div class="overlay-content" v-click-outside="closeModal">
          <navigation-menu :close-modal="closeModal"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationMenu from './NavigationMenu.vue';
import ClickOutside from '../../directives/click-outside';

export default {
  name: 'NavigationOverlay',
  props: {
    isOpen: Boolean,
  },
  components: {
    NavigationMenu,
  },
  directives: {
    ClickOutside,
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .page-overlay {
    font-family: SimplerPro;
    position: fixed; // TODO add somthing from elsa that disable scroll from background
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: rgba(43, 50, 59, 0.5);
    overflow-y: auto;
    scroll-behavior: smooth;

    .content-wrapper {
      max-width: 420px;
      width: 100%;

      .overlay-content {
        height: 100%;
        width: calc(100% - 70px);
      }
    }
  }

  @media (min-width: 430px) {
    .navigation-overlay {
      width: 100%;
      margin: calc(100vh*0.05) 0;
      display: flex;
      justify-content: center;

      .page-overlay {
        width: 400px;
        height: calc(100vh - 100vh*0.1 - 35px - 20px);
      }
    }
  }
</style>
